export const SEARCH_TEXT_KEY = 'data_disney_com_cpm.titleNameDisambiguated'
export const SEARCH_PRODUCT_ID_KEY = 'data_disney_com_cpm.productId'
export const SEARCH_TYPE_KEY = 'www_w3_org_1999_02_22-rdf-syntax-ns.type'
export const SEARCH_DESCRIPTORS_KEY = 'data_disney_com_storyContent'
export const SEARCH_RELEASE_DATE_KEY = 'data_disney_com_cpm.earliestReleaseDate'
export const SEARCH_PUBLISHED_DATE_KEY = 'data_disney_com_creativeWork.hasModifiedDateTime'
export const SEARCH_LOCATION_KEY = 'data_disney_com_creativeWork.setIn'
